import { ChangeEvent, InputHTMLAttributes } from 'react'

import * as S from './styles'
import { Image } from '../image'
import { SearchIcon } from '@/assets/icons'

export type InputSearchProps = InputHTMLAttributes<HTMLInputElement> & {
  search: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  className: string
}
export const InputSearch: React.FC<InputSearchProps> = ({
  search,
  onChange,
  className,
  ...props
}) => (
  <S.SearchContainer className={className}>
    <Image src={SearchIcon} alt="search" className="search-icon" />
    <input
      className="search"
      onChange={(e) => onChange(e)}
      value={search}
      {...props}
    />
  </S.SearchContainer>
)
